module.exports = __webpack_public_path__ + "static/img/SPH.e8436d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/SPH.png
// module id = WOE2
// module chunks = 1